import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import Alert from "@trainline-shareable/alert";
import useJourneyPlan from "../../hooks/useJourneyPlan";
import isTransferLeg from "../../utils/legs/isTransferLeg";
import ConnectionLeg from "../ConnectionLeg";
import DisruptionsAlert from "../DisruptionsAlert";
import LocalAreaTransportAddons from "../LocalAreaTransportAddons";
import TransferLeg from "../TransferLeg";
import TransitLeg from "../TransitLeg";
import * as s from "./JourneyTrack.module.css";
const JourneyTrack = () => {
  const { legs, isOvertaken, localAreaTransportAddons: addons } = useJourneyPlan();
  return /* @__PURE__ */ React.createElement("div", {
    className: s.journeyTrack
  }, isOvertaken && /* @__PURE__ */ React.createElement(Alert, {
    variant: "info",
    className: s.alert
  }, /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "transitLeg.overtakenTrain"
  })), (addons == null ? void 0 : addons.origin) && /* @__PURE__ */ React.createElement(LocalAreaTransportAddons, {
    addons: addons == null ? void 0 : addons.origin
  }), legs.map((leg) => /* @__PURE__ */ React.createElement(Fragment, {
    key: leg.id
  }, /* @__PURE__ */ React.createElement(DisruptionsAlert, {
    legId: leg.id
  }), /* @__PURE__ */ React.createElement("div", {
    className: s.paddedContent
  }, isTransferLeg(leg) ? /* @__PURE__ */ React.createElement(TransferLeg, {
    legId: leg.id
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TransitLeg, {
    legId: leg.id
  }), /* @__PURE__ */ React.createElement(ConnectionLeg, {
    legId: leg.id
  }))))), (addons == null ? void 0 : addons.destination) && /* @__PURE__ */ React.createElement(LocalAreaTransportAddons, {
    addons: addons == null ? void 0 : addons.destination
  }));
};
var JourneyTrack_default = JourneyTrack;
export {
  JourneyTrack_default as default
};
